import { render, staticRenderFns } from "./LicenseInfo.vue?vue&type=template&id=a59ddc8e"
import script from "./LicenseInfo.vue?vue&type=script&lang=js"
export * from "./LicenseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports